import React, { useState } from 'react';
import Pagination from '../../pagination';
import NProgress from 'nprogress';
import Loading from '../../loading';
import useSoftwareInfoByUser from '../../../hooks/use-software-info-by-user';
import SoftwareInfoItem from '../software-info-item';

interface Props {
  customer: any;
}

const SoftwareOrdersByUser: React.FC<Props> = ({ customer }) => {
  const [pageIndex, setPageIndex] = useState(1);

  const softwareInfo = useSoftwareInfoByUser(customer.id, pageIndex - 1, 10);

  if (!softwareInfo) {
    NProgress.start();
    return <Loading message="Loading software order information..." />;
  }

  NProgress.done();

  const info = softwareInfo.content;

  return (
    <React.Fragment>
      <div className="order-grid">
        <div className="order-tile header">
          <span>Order Number</span>
          <span>Order Date</span>
          <span>VIN</span>
          <span>Model Year</span>
          <span>Vehicle Type</span>
          <span>Download</span>
          <span>Price</span>
          <span>Credit</span>
          <span>{''}</span>
        </div>
        {info.map((i) => {
          return <SoftwareInfoItem key={i.order.softwareOrderId} info={i} />;
        })}
      </div>
      <Pagination
        onPageChange={(page) => setPageIndex(page)}
        totalCount={softwareInfo.totalElements}
        siblingCount={1}
        currentPage={pageIndex}
        pageSize={10}
      />
      {/* language=CSS */}
      <style jsx>{`
        a {
          color: #333;
          display: block;
          font-family: 'Volvo Novum', sans-serif;
          margin-bottom: 1rem;
          text-decoration: none;
          transition: color 200ms linear;
        }

        a:hover {
          color: #707070;
        }

        .order-grid {
          margin-top: 3rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .order-tile {
          display: flex;
        }

        .order-tile span:first-child {
          flex: 1 0 10%;
        }

        .order-tile span:nth-child(3) {
          flex: 1 0 20%;
        }

        .order-tile span:last-child {
          flex: 1 0 15%;
        }

        .order-tile span {
          /*cursor: pointer;*/
          flex: 1 0 10%;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          font-weight: 400;
        }

        .order-tile.header span {
          color: #707070;
          padding: 0 0 1rem;
          border-bottom: 1px solid #ddd;
        }
      `}</style>
    </React.Fragment>
  );
};

export default SoftwareOrdersByUser;
